import { Backend } from '@/services/Backend';
import type { User } from '@/models/User';

export type { User };

export class Auth extends Backend {
    protected baseUrl = '';
    private csrfToken: string = '';

    private async fetchCsrf(): Promise<void> {
        const { token } = await this.get<{ token: string }>('/auth/csrf');
        this.csrfToken = token;
    }

    public me(): Promise<{ user: User | null; canRegister: boolean }> {
        return this.get('/auth/me');
    }

    public async login(email: string, password: string, remember: boolean = false): Promise<User | { twoFactorRequired: true }> {
        await this.fetchCsrf();
        return this.post('/auth/login', { email, password, remember }, {
            headers: { 'X-CSRF-Token': this.csrfToken },
        });
    }

    public async register(name: string, email: string, password: string, passwordConfirmation: string, remember: boolean = false, turnstileToken: string = ''): Promise<User> {
        await this.fetchCsrf();
        return this.post('/auth/register', { name, email, password, passwordConfirmation, remember, turnstileToken }, {
            headers: { 'X-CSRF-Token': this.csrfToken },
        });
    }

    public async verifyTotp(code: string): Promise<User> {
        return this.post('/auth/totp', { code }, {
            headers: { 'X-CSRF-Token': this.csrfToken },
        });
    }

    public logout(): Promise<void> {
        return this.post('/auth/logout');
    }
}
